import React from 'react';
import PlanSelectionScreenEnhanced from '../../src/screens/auth/PlanSelectionScreenEnhanced';
import { useAuth } from '../../src/context/AuthContext';

export default function PlanSelectionRoute() {
  const { refreshAuth } = useAuth();

  return (
    <PlanSelectionScreenEnhanced
      onPlanSelected={() => {
        refreshAuth();
      }}
    />
  );
}
